import Reveal from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "A calm space.",
    body: "No noise, no clutter, no endless feeds. My Life opens softly and greets you like a friend who remembers your name and wishes you well.",
  },
  {
    n: "02",
    title: "Holistic by design.",
    body: "Your day, your health, your people and your plans — gently gathered into one place, so nothing important slips quietly through the cracks.",
  },
  {
    n: "03",
    title: "Gentle guidance.",
    body: "A thoughtful health tip each day, warm reminders for birthdays and anniversaries, and quiet nudges toward the life you want to live.",
  },
  {
    n: "04",
    title: "Yours, unhurried.",
    body: "Built for presence, not pressure. My Life moves at your pace and asks only that you show up as you are, one gentle day at a time.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-24 md:py-40" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-[#2B2B26]/60 mb-6">
          The manifesto
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#2B2B26] max-w-3xl mb-16 md:mb-24">
          We believe wellbeing should feel like a quiet morning — unhurried, warm, and
          entirely your own.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 md:gap-y-24">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08} className={i % 2 === 1 ? "md:mt-16" : ""}>
            <div className="border-t border-[#2B2B26]/15 pt-6" data-testid={`manifesto-chapter-${c.n}`}>
              <span className="font-serif text-5xl text-[#1877F2]/80 leading-none">{c.n}</span>
              <h3 className="font-serif text-2xl sm:text-3xl text-[#2B2B26] mt-5 mb-3">
                {c.title}
              </h3>
              <p className="font-body text-base leading-relaxed text-[#2B2B26]/70 max-w-md">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
